import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-dark-800 text-white p-4 text-center">
            <p>&copy; 2024 Ahmed Mohammed. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
